import { render, staticRenderFns } from "./CompanyNewsView.vue?vue&type=template&id=6911ed85&scoped=true"
import script from "./CompanyNewsView.vue?vue&type=script&lang=js"
export * from "./CompanyNewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911ed85",
  null
  
)

export default component.exports